import { SdkPlugin } from "@/core/plugin";
import { FloatingController } from "@/plugins/floating/floating";

import type { SdkContext, ISdkPluginClass } from "@/interface/sdk";

/**
 * Bind 插件：
 * 负责初始化 FloatingController 等绑定类逻辑。
 */
export class FloatingPlugin extends SdkPlugin {
  static pluginName = "Floating" as const;
  static requires: ISdkPluginClass[] = [];

  private floating?: FloatingController;

  async init(ctx: SdkContext): Promise<void> {
    const opts = ctx.options;
    if (!opts) {
      return;
    }

    if (opts.floating !== undefined) {
      this.floating = new FloatingController(document.body);
      void this.floating.init(opts.floating, opts.appId);
      this.floating.linkType = opts.type;
    }
  }

  userEnd(_context: SdkContext): void {
    // console.log(context);
  }
}

/**
 * 模块扩展：将 FloatingPlugin 注册到插件注册表
 *
 * 使用 typeof 自动从 pluginName 推断类型，确保插件名称只需定义一次。
 */
declare module "@/interface/plugin-registry" {
  interface PluginRegistry {
    [FloatingPlugin.pluginName]: FloatingPlugin;
  }
}
